import classnames from 'classnames';

import style from './SelectionButton.module.scss';

import { Nullable } from 'chaika-frontend-types/frontend-cms';

export interface SelectionButtonProps {
    label: string;
    dataTest?: string;
    isSelected: boolean;
    columnDirection?: boolean;
    disabled?: boolean;
    modifiers?: SelectionButtonModifiers[];
    theme?: SelectionButtonTheme;
}

interface Props extends SelectionButtonProps {
    value: Nullable<string | number>;
    onSelect: Nullable<(value: Nullable<string | number>) => void>;
}

export enum SelectionButtonModifiers {
    // @ts-ignore
    Small = style.small,
    // @ts-ignore
    Medium = style.medium,
    // @ts-ignore
    WidePadding = style.widePadding,
}

export enum SelectionButtonTheme {
    // @ts-ignore
    Blue = style.blue,
    // @ts-ignore
    Azure = style.azure,
    // @ts-ignore
    AzureBold = style.azureBold,
    // @ts-ignore
    AzureNew = style.azureNew,
}

export function SelectionButton({
    label,
    columnDirection,
    isSelected,
    dataTest,
    disabled,
    theme,
    value,
    onSelect,
    modifiers = [],
}: Props) {
    const resolvedDataTest = !!dataTest ? `${dataTest}_${value}` : undefined;

    function handleClick() {
        if (onSelect) {
            onSelect(value);
        }
    }

    return (
        <div
            role="button"
            aria-pressed={isSelected}
            aria-disabled={disabled || undefined}
            className={classnames([
                style.root,
                theme,
                columnDirection && style.root_columnDirection,
                isSelected && style.selected,
                disabled && style.disabled,
                ...modifiers,
            ])}
            onClick={disabled ? undefined : handleClick}
            data-test={resolvedDataTest}
            data-testid={resolvedDataTest}
        >
            {label}
        </div>
    );
}
